import { createTheme, Theme } from '@mui/material/styles';

export const theme: Theme = createTheme({
  typography: {
    fontFamily: "'Montserrat', sans-serif",
    fontWeightLight: 400,
    fontWeightRegular: 500,
    fontWeightMedium: 600,
    fontWeightBold: 700,
    body1: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: '1rem',
      lineHeight: 1.5,
      color: '#1E1E1F',
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.43,
      color: '#1E1E1F',
    },
    h1: {
      fontSize: '2rem',
      fontWeight: 600,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '1.75rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
  },
  palette: {
    primary: {
      main: '#005393',
    },
    secondary: {
      main: '#EDF5FA',
    },
    common: {
      white: '#fff',
      black: '#000',
    },
    background: {
      default: '#FBFBFD',
    },
    text: {
      primary: '#1E1E1F',
      secondary: '#6e6e6e',
    },
    error: {
      main: '#E21824',
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "'Montserrat', sans-serif",
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: "'Montserrat', sans-serif",
        },
        '*': {
          fontFamily: "'Montserrat', sans-serif",
          boxSizing: 'inherit',
        },
        img: {
          cursor: 'pointer',
          '&:disabled, &[aria-disabled="true"], &.disabled': {
            cursor: 'not-allowed',
            opacity: 0.5,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&:hover .MuiOutlinedInput-notchedOutline': {},
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {},
          border: 'none !important',
        },

        notchedOutline: {
          borderWidth: '1px',
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        paper: {
          backgroundColor: '#fff',
          color: '#000',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: '#000',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          padding: '4px 12px',
          backgroundColor: '#F8F8F8',
          color: 'BLACK',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'capitalize',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "'Montserrat', sans-serif",
          fontSize: '12px',
          textTransform: 'none',
          background: '#E21824',
          color: 'white',
          '&:hover': {
            cursor: 'pointer',
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundColor: '#fff',
          color: '#000',
          fontFamily: "'Montserrat', sans-serif",
        },
      },
    },
    MuiSkeleton: {
      styleOverrides: {
        root: {
          backgroundColor: '#6e575321',
          borderRadius: 5,
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        track: { border: 'none', backgroundColor: '#0d98cf', height: 10 },
        rail: { color: '#fff', border: '1px solid grey', height: 10 },
        thumb: { backgroundColor: '#0398fc' },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: '#003366',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#000',
          '&.Mui-checked': {
            color: 'red',
          },
          '&.MuiCheckbox-indeterminate': {
            color: 'red',
          },
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          '& .MuiTypography-root': {
            fontFamily: "'Montserrat', sans-serif",
            fontSize: '9px !important',
            fontWeight: 500,
            lineHeight: '13.35px',
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          background: '#005EA6',
          color: '#fff',
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          '&.Mui-checked': {
            transform: 'translateX(24px)',
          },
        },
        thumb: {
          borderRadius: '50%',
          width: '20px',
          height: '20px',
          color: '#E81C0E',
        },
        track: {
          borderRadius: 12,
          backgroundColor: 'grey',
          opacity: 1,
          '&.Mui-checked': {
            backgroundColor: 'grey',
          },
        },
      },
    },
  },
});
